export enum MeetingTypeEnum {
  MEETING = 'MEETING',
  LUNCH_DINNER_DRINKS = 'LUNCH_DINNER_DRINKS',
  EXTERNAL_CONFERENCE_ATTENDANCE = 'EXTERNAL_CONFERENCE_ATTENDANCE',
  CLIENT_NETWORKING_EVENT = 'CLIENT_NETWORKING_EVENT'
}
